import React from 'react'
import { compose } from 'react-apollo'
import { Link, withRouter } from 'react-router-dom'
import {
  Form,
  Button,
  TextInput,
  Checkbox
} from 'carbon-components-react'

import Validator from '../utils/Validator'
import RegistrationValidator from '../validators/Registration'

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  terms: false,
  initialErrors: {},
  errors: {}
}

class RegistrationForm extends Validator {
  state = { ...initialState }

  constructor(props) {
    super(props)
    this.validator = RegistrationValidator
  }

  submit() {
    this.props.onSubmit(this.state)
  }

  render() {
    const {
      firstName,
      lastName,
      terms,
      errors,
      email,
      password,
      passwordConfirmation
    } = this.state

    return (
      <Form onSubmit={this.handleSubmit}>
        <div className='formRow'>
          <TextInput id='firstName'
            name='firstName'
            labelText='First Name *'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={firstName || ''}
            invalid={errors.firstName ? true : false}
            invalidText={errors.firstName || ''} />
        </div>
        <div className='formRow'>
          <TextInput id='lastName'
            name='lastName'
            labelText='Last Name *'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={lastName || ''}
            invalid={errors.lastName ? true : false}
            invalidText={errors.lastName || ''} />
        </div>
        <div className='formRow'>
          <TextInput id='email'
            name='email'
            labelText='Email *'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={email || ''}
            invalid={errors.email ? true : false}
            invalidText={errors.email || ''} />
        </div>
        <div className='formRow'>
          <TextInput id='password'
            name='password'
            labelText='Password *'
            type='password'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={password || ''}
            invalid={errors.password ? true : false}
            invalidText={errors.password || ''} />
        </div>
        <div className='formRow'>
          <TextInput id='passwordConfirmation'
            name='passwordConfirmation'
            labelText='Confirm Password *'
            type='password'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={passwordConfirmation || ''}
            invalid={errors.passwordConfirmation ? true : false}
            invalidText={errors.passwordConfirmation || ''} />
        </div>
        <div className='formRow terms-conditions'>
          <Checkbox name='terms' id='terms' labelText={
            <span>I agree to the <a href='https://www.vevacollect.com/terms-and-conditions' target='_blank' rel='noopener noreferrer'>Terms & Conditions</a></span>
          }
          checked={terms}
          onChange={(e) => {
            this.handleChange({
              target: {
                name: 'terms',
                value: e
              }
            })
          }} />
          {errors.terms &&
          <div className='bx--form-requirement visible'>{errors.terms}</div>
          }
        </div>
        <div className='alternateOption success-message'>Already have an account? <Link to='/login'>Login</Link></div>
        <div className='formRow mb-0 register-btn'>
          <Button type='submit' className='loginSubmit register-submit'>
            { this.props.loading ? 'Registering...' : 'Register' }
          </Button>
        </div>
      </Form>
    )
  }
}

export default compose(withRouter)(RegistrationForm)
